import React, { useMemo, useState } from 'react';
import { Select } from 'antd';

const MultiSelect = ({ fieldId, formData, setFormData, options, placeholder, width = '100%', height = '38px' }) => {
    const [search, setSearch] = useState('');

    const onChangeSelection = (fieldId, selected) => setFormData(formData => ({ ...formData, [fieldId]: selected }))

    const filteredOptions = useMemo(() => {

        if (!search) return options;

        return options.filter(item =>
            item.label
                .toLowerCase()
                .includes(search.toLowerCase())
        );

    }, [search, options]);

    const selectProps = {
        mode: 'multiple',
        style: {
            width: width,
            height: height
        },
        value: typeof formData?.[fieldId] == 'string' ? JSON.parse(formData?.[fieldId]) : formData?.[fieldId] || [],
        placeholder: placeholder,
        maxTagCount: 'responsive',
        filterOption: false,
        options: filteredOptions,
    };

    return (
        <Select
            showSearch
            {...selectProps}
            onSearch={setSearch}
            onChange={(val) => onChangeSelection(fieldId, val)}
        />
    );
};
export default MultiSelect;